module.exports = __webpack_public_path__ + "img/chevrons-left.59c33fdc.svg";